<div class="d-flex flex-column gap-1">
  @if (title()) {
    <div class="d-flex align-items-center gap-2 mb-1">
      <mat-icon class="mat-icon-sm mat-text-on-surface-variant">checklist</mat-icon>
      <span class="mat-font-label-sm fw-semibold mat-text-on-surface-variant">{{ title() }}</span>
    </div>
  }
  @for (todo of todos(); track $index) {
    <div class="d-flex align-items-start gap-2">
      @switch (todo.status) {
        @case ('completed') {
          <mat-icon class="mat-text-primary flex-shrink-0 mat-icon-sm">check_circle</mat-icon>
        }
        @case ('in_progress') {
          <span class="todo-list__spinner"></span>
        }
        @default {
          <mat-icon class="mat-text-on-surface-variant flex-shrink-0 mat-icon-sm">radio_button_unchecked</mat-icon>
        }
      }
      <span
        class="mat-font-label-sm mat-text-on-surface-variant flex-fill"
        [class.text-decoration-line-through]="todo.status === 'completed'"
      >{{ todo.content }}</span>
    </div>
  }
</div>
